import { ReactNode } from 'react';
import Box from '@mui/material/Box';

import { ExpandableFeatureLayout } from '@lendica/components';

import { useData } from './contexts/useData';
import { useContainerWidth } from '@lendica/hooks';

export const Layout = ({ children }: { children: ReactNode }) => {
    const { loading } = useData() as { loading: boolean };
    const { isNarrow } = useContainerWidth();

    return (
        <ExpandableFeatureLayout maxWidth={1280} loading={loading}>
            <Box
                sx={{
                    p: isNarrow ? 2 : 4,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    overflow: 'auto',
                    boxSizing: 'border-box',
                }}
            >
                {children}
            </Box>
        </ExpandableFeatureLayout>
    );
};
